export default __webpack_public_path__ + "static/media/les_andelys13.1e737dca.jpg";